


























































































































































/** @format */
import { Component, Mixins, Watch } from 'vue-property-decorator';
import TableMixin from '@root/common/mixins/table';
import TableWidthMixin from '@root/common/mixins/table-width';
// 下拉框封装组件
import ParkingLotSearch from '@/components/parking-lot-search/index.vue';
import { couponList, deleteCoupon, disableCoupon, couponExport, couponDetail } from '@/api/discount-management/index';
import { couponTypeMap, couponStatusMap } from '@/types/discount-management/dictionaries';
import Utils from '@root/utils/common';
import AddEditModal from './components/add-edit-model.vue';
import OrganizationSearch from '../../../components/organization-search/index.vue';
import CountCardSimpleGrid from '@/components/count-card/simple-grid.vue';
import * as _ from 'lodash';
@Component({
  name: 'CouponList',
  components: { ParkingLotSearch, AddEditModal, OrganizationSearch, CountCardSimpleGrid }
})
export default class CouponList extends Mixins(TableMixin, TableWidthMixin) {
  private filterParam: any = {
    parkIds: [], //选中的车场
    merchantName: '',
    types: [],
    couponStatus: '',
    merchantType: '',
    orgdepId: ''
  };
  //options = Utils.toLabelVal(couponTypeMap)
  // options = _.filter(
  //   Utils.toLabelVal(this.$store.state.dictionaries.allDictionaries.cp_merchant_coupon_coupon_type),
  //   function(o) {
  //     o.label = `${o.label}`;
  //     return o.value != '04';
  //   }
  // );
  options = Utils.toLabelVal(this.$store.state.dictionaries.allDictionaries.cp_merchant_coupon_coupon_type);
  couponStatusOptions = Utils.toLabelVal(this.$store.state.dictionaries.allDictionaries.cp_merchant_coupon_enabled);
  businessTypeOptions = Utils.toLabelVal(this.$store.state.dictionaries.allDictionaries.cp_merchant_merc_type);
  private tableLoading: boolean = false;
  editModel: boolean = false; //弹出框是否显示
  tableData: any[] = [];
  isEdit: boolean = false;
  addEditModalData: any = null;
  totalCount: any[] = [];
  // 合计数据
  private sumRowData: any = {};
  //table列表
  get tableColums() {
    return [
      {
        title: '序号',
        width: 55,
        customRender: (text: any, record: any, index: number) => {
          if (record.isTotal === true) {
            return '总合计';
          }
          return `${(this.current - 1) * this.pageSize + index + 1}`;
        }
      },
      {
        title: '适用车场',
        dataIndex: 'parkName',
        width: 180,
        scopedSlots: { customRender: 'text-ellipse-to-tip' }
      },
      {
        title: '所属机构',
        dataIndex: 'orgDepName',
        width: 180,
        scopedSlots: { customRender: 'text-ellipse-to-tip' }
      },
      {
        title: '商户类型',
        dataIndex: 'merchantType',
        width: 180,
        scopedSlots: { customRender: 'text-ellipse-to-tip' }
      },
      {
        title: '商户名称',
        dataIndex: 'merchantName',
        width: 180,
        scopedSlots: { customRender: 'text-ellipse-to-tip' }
      },
      {
        title: '优惠券名称',
        dataIndex: 'name',
        width: 180,
        scopedSlots: { customRender: 'text-ellipse-to-tip' }
      },
      // {
      //   title: '优惠券类型',
      //   dataIndex: 'type',
      //   width: 140,
      //   customRender: (text: any) => text || '--',
      // },
      {
        title: '优惠券类型',
        dataIndex: 'type',
        width: 140,
        customRender: (text: any) => text || '--'
      },
      {
        title: '优惠数额',
        dataIndex: 'value',
        width: 140,
        customRender: (text: any, record: any) => {
          if (record.type === '时段优惠券') {
            return '全免';
          }
          return text || '--';
        }
      },
      {
        title: '优惠批号',
        dataIndex: 'batchNo',
        width: 340,
        customRender: (text: any) => text || '--'
      },
      {
        title: '总张数',
        dataIndex: 'totalNum',
        width: 120,
        customRender: (text: any) => text || '--'
      },
      {
        title: '剩余张数',
        dataIndex: 'remainderNum',
        width: 140,
        customRender: (text: any) => text || '--'
      },
      {
        title: '每日上限',
        dataIndex: 'dayLimitNum',
        width: 140,
        customRender: (text: any) => (text == '0' ? '不限制' : text || '--')
      },
      {
        title: '今日已发',
        dataIndex: 'todaySendNum',
        width: 140,
        customRender: (text: any) => text || '--'
      },
      {
        title: '今日剩余',
        dataIndex: 'todayRemainderNum',
        width: 140,
        customRender: (text: any) => text || '--'
      },
      {
        title: '单次停车发放上限',
        dataIndex: 'singleReceiveLimitNum',
        width: 140,
        customRender: (text: any) => (text == '0' ? '不限制' : text || '--')
      },
      {
        title: '预发售',
        dataIndex: 'advanceSaleStatus',
        width: 140,
        customRender: (text: any) => text || '--'
      },
      {
        title: '结算价',
        dataIndex: 'settlementPrice',
        width: 140,
        customRender: (text: any) => text || '--'
      },
      {
        title: '总结算金额',
        dataIndex: 'settlementTotalPrice',
        width: 200,
        customRender: (text: any) => text || '--'
      },
      {
        title: '有效期',
        dataIndex: 'effectiveDate',
        width: 240,
        scopedSlots: { customRender: 'effectiveDate' }
      },
      {
        title: '创建时间',
        dataIndex: 'createTime',
        width: 200,
        customRender: (text: any) => text || '--'
      },
      {
        title: '状态',
        dataIndex: 'status',
        width: 140,
        scopedSlots: { customRender: 'status' }
      },
      {
        title: '操作',
        dataIndex: 'operation',
        fixed: 'right',
        width: 160,
        scopedSlots: { customRender: 'operation' }
      }
    ];
  }
  //获取优惠券类型
  getTypeName(val: any) {
    return couponTypeMap[val];
  }
  //获取状态名称
  getStatusName(val: any) {
    return couponStatusMap[val];
  }
  private showSizeChangerChange(current: any, pageSize: any) {
    this.current = current;
    this.pageSize = pageSize;
    this.fetchTableData();
  }
  changeShowFlag(val) {
    this.showFlag = val;
  }
  //table初始化
  async fetchTableData(refresh?: any) {
    if (refresh) this.current = 1;
    if (this.tableLoading) return;
    this.tableLoading = true;
    try {
      // const { parkIds, ...rest } = this.filterParam
      const { status, code, msg, data } = await couponList({
        merchantName: this.filterParam.merchantName,
        types: this.filterParam.types.join(','),
        couponStatus: this.filterParam.couponStatus,
        parkIds: this.filterParam.parkIds.join(','),
        orgdepId: this.filterParam.orgdepId,
        merchantType: this.filterParam.merchantType,
        page: this.current,
        pageSize: this.pageSize
      });
      const {
        datas,
        totalNum,
        durationCouponCount = '',
        moneyCouponCount = '',
        freeCouponCount = '',
        timeFrameCouponCount = '',
        discountCouponCount = '',
        allCouponCount = '',
        allTotalMoney
      } = data;
      this.total = Number(data.totalNum);
      if (datas && datas.length !== 0) {
        this.tableData = datas;
        // this.tableData.push({
        //   settlementTotalPrice: `${allTotalMoney ? allTotalMoney : 0} `,
        //   isTotal: true,
        // })
        this.sumRowData = {
          settlementTotalPrice: `${allTotalMoney ? allTotalMoney : 0} `
        };
      } else {
        this.tableData = [];
      }
      this.totalCount = [];
      this.totalCount.push(
        { title: '全部（种）', count: allCouponCount || 0, countColor: 'warning' },
        { title: '金额优惠（种）', count: moneyCouponCount || 0, countColor: 'primary' },
        { title: '时长优惠（种）', count: durationCouponCount || 0, countColor: 'primary' },
        { title: '单次免费（种）', count: freeCouponCount || 0, countColor: 'primary' },
        { title: '限时免费（种）', count: timeFrameCouponCount || 0, countColor: 'primary' },
        { title: '折扣优惠（种）', count: discountCouponCount || 0, countColor: 'primary' }
      );
    } catch (error) {
      this.$message.error((error && error.msg) || '系统繁忙，请稍后再试');
    } finally {
      this.tableLoading = false;
    }
  }
  //点击搜索
  searchTable() {
    this.fetchTableData(true);
  }
  //清空table
  onTableFilterClear({ defaultParkIdList }) {
    this.filterParam = {
      parkIds: defaultParkIdList,
      name: '',
      types: [],
      couponStatus: '',
      mobile: '',
      orgdepId: '',
      merchantType: ''
    };
    this.searchTable();
  }
  showFlag = false;
  //新增 修改
  async editItem(val?: any) {
    if (val) {
      this.isEdit = true;
      try {
        const { data } = await couponDetail({ id: val.id });
        this.addEditModalData = data ? data : {};
        if (data.merchantType === '04') {
          this.showFlag = true;
        } else {
          this.showFlag = false;
        }
      } catch (error) {
        return this.$message.error((error && error.msg) || '系统繁忙，请稍后再试');
      }
    } else {
      this.isEdit = false;
    }
    this.editModel = true;
  }
  //禁用
  disableItem(val: any) {
    let that = this;
    this.$confirm({
      title: '禁用',
      content: '您确定要把优惠券禁用吗？',
      async onOk() {
        try {
          console.log(val.id);
          const { status, msg, code, data } = await disableCoupon({
            id: val.id
          });
          console.log(status);
          if (status === '9999') {
            that.$message.success('禁用成功');
            that.fetchTableData();
          } else {
            that.$message.error(msg);
          }
        } catch (e) {
          console.log('报错了');
          that.$message.error((e && e.msg) || '禁用失败');
        }
      },
      onCancel() {}
    });
  }
  //删除
  deleteItem(val: any) {
    let that = this;
    if (val.totalNum !== val.remainderNum) return this.$message.error('已发放过优惠券，不能删除优惠券');
    this.$confirm({
      title: '提示',
      content: '您确定要把优惠券删除吗？',
      async onOk() {
        try {
          const { status, msg } = await deleteCoupon({
            id: val.id
          });
          if (status === '9999') {
            that.$message.success('删除成功');
            that.fetchTableData();
          } else {
            that.$message.error(msg);
          }
        } catch (e) {
          that.$message.error((e && e.msg) || '删除失败');
        }
      },
      onCancel() {}
    });
  }
  //导出
  private async downLoad() {
    try {
      await couponExport(
        {
          merchantName: this.filterParam.merchantName,
          types: this.filterParam.types.join(','),
          couponStatus: this.filterParam.couponStatus,
          parkIds: this.filterParam.parkIds.join(','),
          merchantType: this.filterParam.merchantType,
          orgdepId: this.filterParam.orgdepId,
          currPage: this.current,
          pageSize: this.pageSize
        },
        '优惠券管理'
      );
    } catch (e) {
      console.log('couponExport', '导出失败');
    }
  }
  //弹窗取消
  handleModalCancel() {
    this.editModel = false;
  }
  //弹窗保存
  handleModalCreate() {
    this.editModel = false;
    this.fetchTableData(true);
  }
  created() {
    this.fetchTableData();
  }
  // changeParking(value, label, extra) {
  //   if (
  //     extra &&
  //     extra.allCheckedNodes &&
  //     extra.allCheckedNodes[0] &&
  //     extra.allCheckedNodes[0].node &&
  //     extra.allCheckedNodes[0].node.componentOptions &&
  //     extra.allCheckedNodes.length === 1
  //   ) {
  //     if (
  //       extra.allCheckedNodes[0].node.componentOptions.propsData.dataRef &&
  //       extra.allCheckedNodes[0].node.componentOptions.propsData.dataRef.children
  //     ) {
  //       this.orgdepId = extra.allCheckedNodes[0].node.componentOptions.propsData.value
  //     } else {
  //       this.orgdepId = ''
  //     }
  //   } else {
  //     this.orgdepId = ''
  //   }
  //   // console.log(value, '------------------ea')
  //   // console.log(label, '------------------ea')
  //   // console.log(extra, '------------------ea')
  //   // console.log(extra.allCheckedNodes[0].node.componentOptions.propsData.value, '------------------ea')
  //   // console.log(extra.allCheckedNodes[0].node.componentOptions.propsData.title, '------------------ea')
  //   // console.log(extra.allCheckedNodes[0].node.componentOptions.propsData, '------------------ea')
  // }
}
